// extracted by mini-css-extract-plugin
export default {"divider":"skuFood_divider__cS+d9"};